import React, { Component } from "react";

import MainMenu from "../components/mainMenu";
import SubNavigation from "../components/subNavigation";
import TopBanner from "../components/topBanner";
import AnimatedBackground from "../components/animatedBackground";
import InstagramFeed from "../components/instagramFeed";
import Footer from "../components/footer";
import SuitMaterial from "../components/suitMaterial";
import WarmUpSuit from "../components/warmUpSuit";

import ImageCarousel from "../components/imageCarousel";

export default class SuitSkeleton extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.title = "QwixSkinz || Skeleton Race Suits";
	}

	componentWillUnmount() {}

	render() {
		return (
			<React.Fragment>
				<MainMenu />
				<TopBanner
					bannerHeight="full"
					title="Skeleton Suit"
					images={[
						"skeleton/megan-henry-canadian-skeleton-pro-athlete.jpg",
						"skeleton/canada-olympic-skeleton-race-suit.jpg"
					]}
				/>
				<SubNavigation
					location={this.props.location}
					refs={this.refs}
					navItems={[
						{ title: "Elite Suit", id: "overview" },
						{ title: "World Cup Suit", id: "world-cup" },
						{ title: "Material", id: "material" },
						{ title: "Warm Up Suit", id: "warmupsuit" },

						// { title: "Our Athletes", id: "athletes" },
						{ title: "Performance Benefits", id: "performance" }
					]}
				/>
				{/* Bobsled Suit Overview */}
				<div className="qs-b" ref="overview">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">Elite Skeleton Race Suit</h1>
								</div>
							</div>
							<div className="col-12 col-md-6 content dark pt-0">
								<div className="">
									<ImageCarousel
										className="large-media"
										images={[
											"/images/suits/skeleton/IMG_2999.jpg",
											"/images/suits/skeleton/IMG_2987.jpg",
											"/images/suits/skeleton/IMG_2995.jpg",
											"/images/suits/skeleton/IMG_2996.jpg",
											"/images/suits/skeleton/IMG_3002.jpg",
											"/images/suits/skeleton/IMG_3015.jpg",
											"/images/suits/skeleton/IMG_3020.jpg",
											"/images/suits/skeleton/IMG_3023.jpg",
											"/images/suits/skeleton/IMG_3025.jpg",
											"/images/suits/skeleton/olympic-skeleton-canadian-race-suit.jpg",
											"/images/suits/skeleton/custom-fitted-bobsleigh-race-suit.jpg",
											"/images/suits/skeleton/skeleton-ev3-preferred.jpg",
											"/images/suits/skeleton/elisabeth-canada.jpg",
											"/images/suits/skeleton/nac-race-4-skeleton.jpg"
										]}
									/>
								</div>
							</div>
							<div className="col-12 col-md-6">
								<p className="lead">
									The Qwixskinz Elite Skeleton race suit is the one athletes
									turn to for their biggest races. Worn by Gold medal winners at
									World Cup, World Championship &amp; Olympic medalists. Known for
									years for it’s impeccable fit and zero air permeability
									fabrics for the least amount of aerodynamic drag, our Elite
									Skeleton race suit has just taken a BIG step to be even
									farther ahead of the competition.
								</p>
								<p>
									Now in 2018, our new 3D Pattern technology allows us to
									utilize virtual 3D athlete models, wrap the 3D pattern files
									on the form to pinpoint all custom adjustments. Our new
									technology even allows us to replicate race position &amp; detect
									possible fit &amp; stretch issues even before the suit is
									produced! Our new 3D technology will allow Qwixskinz to remain
									the Skeleton racer’s suit of choice!
								</p>
								<ul>
									<li>
										Wind Tunnel tested design that has been refined with
										scientific data
									</li>
									<li>
										Aerodynamic fabric with zero air permeability for the lowest
										aerodynamic drag possible.
									</li>
									<li>
										Lycra inserts for ease &amp; full range of motion in the push
										start
									</li>
									<li>Wrist zippers for perfect glove fit</li>
									<li>Half-foot &amp; hand finishes</li>
									<li>Custom Sizing only.</li>
									<li>
										Our new 3D Pattern technology improves the legendary
										Qwixskinz fit to allow every fit detail to be addressed.
									</li>
									<li>
										Choose from our original, eye catching graphics/artwork
										(colour customizing, personal sponsor logo application &amp; are
										available at an extra charge).
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				{/* Worldcup Race Suit */}
				<div className="qs-b" ref="world-cup">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">World Cup Skeleton Race Suit</h1>
								</div>
							</div>
							<div className="col-12 content dark pt-0">
								<p className="lead">
									Taking the same superior Skeleton Race Suit 3D patterning
									system &amp; utilizing fabrics that allow for an increased stretch
									for the best stock sized fit possible, the Qwixskinz WC
									Skeleton Race Suit is one racers can rely one.
								</p>
								<ul>
									<li>Worn in World Cups &amp; 2018 Olympic Games.</li>
									<li>
										Aerodynamic fabric that blends performance &amp; a superior fit.
									</li>
									<li>
										Available in either Shiny or Matte top layer finishes.
									</li>
									<li>Superior abrasion resistant fabric.</li>
									<li>
										Lycra inserts for ease &amp; full range of motion in the push
										start.
									</li>
									<li>Available in Stock Sizes.</li>
									<li>
										Our new 3D Pattern technology provides the best fitting
										stock sized race suit possible.
									</li>
									<li>
										Choose from our original, eye catching graphics/artwork
										(colour customizing, personal sponsor logo application &amp; are
										available at an extra charge).
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				{/* Suit Material Section */}
				<SuitMaterial ref="material">
					<React.Fragment>
						<div className="section-title">
							<h1 className="title">Suit Material</h1>
						</div>
						<p className="lead">
							At Qwixskinz we work with the world’s leading aerodynamic fabric
							mills to provide the best 3-layer fabric combination for each
							sport.
						</p>
						<p>
							Because our custom fit Elite Skeleton Race Suit uses individual 3D
							Pattern technology to give us the perfect fit, we use zero-air
							permeability fabric with the lowest aerodynamic drag coefficient.
						</p>
						<p>
							This combination of fit &amp; fabric = the fastest race suit on the
							market.
						</p>
						<p>
							Our World Cup Skeleton Race Suit provides the best stock sized
							Skeleton suit available...period. Still benefiting from our 3D
							pattern technology, our WC fabric allows minimal air permeability
							to create the best fit in a stock sized option.
						</p>
					</React.Fragment>
				</SuitMaterial>

				{/* Suit Material Section */}
				<WarmUpSuit ref="warmupsuit" />

				{/* Performace Section */}
				<div className="qs-b" ref="performance">
					<div className="container block-wrap behind-mnt2">
						<div className="d-flex flex-row">
							<div className="col content green ">
								<div className="section-title">
									<h1 className="title">Performance Benefits</h1>

									<p className="lead">
										Our Qwixskinz Elite Race Suit has been evolving &amp; developing
										for years.
									</p>
									<p>
										First, based on wind tunnel testing conducted leading to the
										2010 Vancouver Olympics, our Elite Skeleton Race Suit helped
										Canada’s Jon Montgomery race his way to Skeleton GOLD
										allowing him the winning margin of .07/second. Jon has
										stated since then that if not for his Qwixskinz race suit,
										his medal would have been a different colour!
									</p>
									<p>
										Subsequent fabric evolution, research &amp; development along
										with wind tunnel &amp; on-ice testing have allowed Qwixskinz to
										stay ahead of the competition as racer’s suit of choice.
										When .01/second can mean a medal or leaving empty handed,
										the best in aerodyanmic fabrics &amp; fabric applications are
										key.
									</p>

									<div className="pt-5" />

									<i>*Photo credit: Hector Pachas</i>
								</div>
							</div>
						</div>
					</div>
				</div>

				<InstagramFeed  />
				<Footer />
				<AnimatedBackground />
			</React.Fragment>
		);
	}
}
